import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCampaignIdData } from '../../../components/sections/vehicle-portal/hooks/use-recall-data';
import ServerContext from '../../../contexts/serverContext';
import { PageNotFoundView } from '../../../views';
import BreadcrumbsAndViewBanner from '../../components/breadcrumbs-and-view-banner/breadcrumbs-and-view-banner';
import SupportFdsWrapper from '../../components/support-fds-wrapper/support-fds-wrapper';
import siteMapService from '../../services/site-map-service/site-map-service';
import { useExemptWordsContent } from '../recalls/hook/use-exempt-word-list';
import { useRecallsContent } from '../recalls/hook/use-recalls-content';
import './recalls-campaign-details-container.scss';
import { RecallsCampaignDetails } from './recalls-campaign-details';
import { getRecallsLandingAlias } from '../recalls-details/recalls-util';

interface RecallsCampaignDetailsParams {
    id: string;
}

const RecallsCampaignDetailsContainer = () => {
    const { id } = useParams<RecallsCampaignDetailsParams>();
    const serverContext = useContext(ServerContext);
    const recallsContent = useRecallsContent();
    const campaignDetails = useCampaignIdData(id.toUpperCase());
    const [loading, setLoading] = useState<boolean>(true);
    const exemptWordsContent = useExemptWordsContent();
    const fields = [
        {
            title: recallsContent?.detailsRecallNumberLabel,
            value: `${id.toUpperCase()}${
                campaignDetails?.govtRecallNumber
                    ? '/' + campaignDetails?.govtRecallNumber
                    : ''
            }`,
        },
        {
            title: recallsContent?.detailsIssueDateLabel,
            value: campaignDetails?.localFsaLaunchDate,
        },
        {
            title: recallsContent?.detailsAccordionDescriptionLabel,
            value: campaignDetails?.govtRecallDescEnglish,
        },
        {
            title: recallsContent?.detailsSafetyRiskLabel,
            value: campaignDetails?.govtRecallSafetyRiskDescEnglish,
        },
        {
            title: recallsContent?.detailsRemedyLabel,
            value: campaignDetails?.govtRecallRemedyDescEnglish,
        },
    ];
    const isCsp: boolean = campaignDetails?.fsaTypeDtl?.toLowerCase() === 'csp';
    const currentRoot = serverContext.root
        ? serverContext.root.substring(0, serverContext.root.length - 1)
        : '';

    const RecallPageBreadCrumb = () => {
        const component = getRecallsLandingAlias(
            serverContext.currentLanguageRegionCode,
            serverContext.brand
        );

        return (
            <>
                <a
                    className="breadcrumb-link"
                    href={`${currentRoot}${siteMapService
                        .getPathFromRouterConfigs(
                            serverContext.currentLanguageRegionCode,
                            serverContext.brand,
                            component,
                            []
                        )
                        .replace(':vinOrModel?/:year?/', '')}`}
                >
                    <span>{recallsContent?.title}</span>
                </a>
                <span className="back-slash">{'>'}</span>
            </>
        );
    };

    useEffect(() => {
        campaignDetails ? setLoading(false) : setLoading(true);
    }, [campaignDetails]);

    return recallsContent ? (
        <SupportFdsWrapper>
            <BreadcrumbsAndViewBanner
                currentPage={`${id.toUpperCase()}`}
                previousCrumb={<RecallPageBreadCrumb />}
                hashId={'support'}
            />
            `
            <RecallsCampaignDetails
                campaignDetails={campaignDetails}
                recallsContent={recallsContent}
                loading={loading}
                exemptWordsContent={exemptWordsContent}
                fields={fields}
                isCsp={isCsp}
            />
        </SupportFdsWrapper>
    ) : (
        <PageNotFoundView />
    );
};
export default RecallsCampaignDetailsContainer;
